<template>
  <v-dialog v-model="value" hide-overlay persistent width="60%">
    <v-card>
      <v-card-title>
        <span class="text-h5">
          {{
            $t('feedbacks.createWithType', {
              processType: $t(`feedbacks.processTypes.${processType}`)
            })
          }}
        </span>
      </v-card-title>
      <v-card-text>
        {{
          $t('feedbacks.createWithType_Info', {
            processType: $t(`feedbacks.processTypes.${processType}`)
          })
        }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="secondary" @click="$emit('close')">
          {{ $t('no') }}
        </v-btn>
        <v-btn text color="blue darken-1" @click="$emit('create')">
          {{ $t('yes') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    processType: {
      type: Number,
      required: true
    }
  }
};
</script>
